import * as StoryApi from './StoryApi';
import StoryConstants from './StoryConstants';

import * as PostActions from '../posts/PostActions';
import * as SlideActions from '../slides/SlideActions';
import {failureNotification} from "Data/notifications/NotificationActions";

const receivedStory = (story) => ({
    type: StoryConstants.STORY_RECEIVED,
    payload: {
        id: story.id,
        name: story.name,
        description: story.description,
        public_url: story.public_url,
        account_id: story.account_id,
        slides: story.slides,
        projects: story.projects,
        created_at: story.created_at,
        updated_at: story.updated_at,
        published_at: story.published_at,
    }
});

const removedStory = (storyId) => ({
    type: StoryConstants.STORY_REMOVED,
    payload: {
        id: storyId,
    }
});

const renamedStory = (storyId, name) => ({
    type: StoryConstants.STORY_RENAMED,
    payload: {
        id: storyId,
        name: name
    }
});

const storyDescriptionChanged = (storyId, description) => ({
    type: StoryConstants.STORY_DESCRIPTION_CHANGED,
    payload: {
        id: storyId,
        description: description
    }
});

const updatedStoryProjects = (storyId, projectIds) => ({
    type: StoryConstants.STORY_PROJECTS_UPDATED,
    payload: {
        id: storyId,
        projects: projectIds
    }
});

const creatingPosts = (storyId) => ({
    type: StoryConstants.STORY_CREATING_POSTS,
    payload: {
        id: storyId,
    }
});

const publishingStory = (storyId) => ({
    type: StoryConstants.STORY_PUBLISHING,
    payload: {
        id: storyId,
    }
});

const publishedStory = (storyId, publicUrl, publishedAt) => ({
    type: StoryConstants.STORY_PUBLISHED,
    payload: {
        id: storyId,
        public_url: publicUrl,
        published_at: publishedAt,
    }
});

const unpublishingStory = (storyId) => ({
    type: StoryConstants.STORY_UNPUBLISHING,
    payload: {
        id: storyId,
    }
});

const unpublishedStory = (storyId) => ({
    type: StoryConstants.STORY_UNPUBLISHED,
    payload: {
        id: storyId,
    }
});


export function removeStory(storyId) {
    return function (dispatch, getState) {
        dispatch(removedStory(storyId));

        return StoryApi.removeStory(storyId);
    }
}

export function fetchStoryList(storyId) {
    return function (dispatch) {
        return StoryApi.listStories(storyId).then(response => {
            response.map(story => dispatch(receivedStory(story)));
            return response;
        });
    };
}

export function fetchStory(storyId) {
    return function (dispatch, getState) {
        return StoryApi.getStory(storyId).then(response => {
            dispatch(receivedStory(response))
        })
    }
}

export function createStory(accountId, name, description, projectIds) {
    return function (dispatch) {
        return StoryApi.createStory(accountId, name, description, projectIds).then(story => {
            dispatch(fetchStoryList(accountId));

            return story;
        });
    };
}

export function renameStory(storyId, name) {
    return function (dispatch) {
        dispatch(renamedStory(storyId, name));

        return StoryApi.renameStory(storyId, name).then(() => {
            dispatch(fetchStory(storyId))
        });
    };
}

export function changeStoryDescription(storyId, description) {
    return function (dispatch) {
        dispatch(storyDescriptionChanged(storyId, description));

        return StoryApi.changeStoryDescription(storyId, description).then(() => {
            dispatch(fetchStory(storyId))
        });
    };
}

export function updateProjects(storyId, projectIds) {
    return function (dispatch) {
        dispatch(updatedStoryProjects(storyId, projectIds));

        return StoryApi.updateProjects(storyId, projectIds).then(() => {
            dispatch(fetchStory(storyId))
        });
    }
}

export function createPosts(storyId, integrationIds) {
    return function (dispatch, getState) {
        dispatch(creatingPosts(storyId));

        const creations = [];

        for (const integrationId of integrationIds) {
            creations.push(StoryApi.createPost(storyId, integrationId));
        }

        return Promise.all(creations)
            .then(() => {
                dispatch(PostActions.listPosts(getState().currentAccountId));
            })
            .catch(error => {
                dispatch(failureNotification('Failed to create a Post.'));
                throw error;
            });
    };
}

export function publishStory(storyId) {
    return function (dispatch, getState) {
        dispatch(publishingStory(storyId));

        return StoryApi.publishStory(storyId).then(() => {
            dispatch(fetchStory(storyId));
        });
    };
}

export function unpublishStory(storyId) {
    return function (dispatch, getState) {
        const unpublishingAction = unpublishingStory(storyId);
        const unpublishedAction = unpublishedStory(storyId);

        dispatch(unpublishingAction);

        return StoryApi.unpublishStory(storyId).then(() => {
            dispatch(unpublishedAction);
        });
    }
}

export function duplicate(storyId) {
    return function (dispatch, getState) {
        return StoryApi.duplicate(storyId).then((response) => {
            dispatch(fetchStory(response.id));
            dispatch(SlideActions.listSlides(response.id));
            return response;
        });
    }
}
